import React from 'react';
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Input from "@cloudscape-design/components/input";
import Select from "@cloudscape-design/components/select";
import RadioGroup from "@cloudscape-design/components/radio-group";
import Button from "@cloudscape-design/components/button";
import { ApiConfig } from './types';
import { SelectProps } from "@cloudscape-design/components/select";
import { fetchSuperStarDropDownOptions } from "src/components/onboardingServiceUtils";
import {RESOURCE_REGEX_PATTERN} from "src/constants";

interface APIOnboardingSectionProps {
    formData: ApiConfig;
    setFormData: (data: ApiConfig) => void;
    superStarNameOptions: SelectProps.Options;
    setSuperStarNameOptions: (options: SelectProps.Options) => void;
    showErrors: boolean;
    aaaIdentifierPattern: RegExp;
}

const RequiredField = ({ label }: { label: string }) => (
    <label>
        {label}
        <span style={{ color: "red", marginLeft: "4px" }}>*</span>
    </label>
);

const APIOnboardingSection: React.FC<APIOnboardingSectionProps> = ({
                                                                       formData,
                                                                       setFormData,
                                                                       superStarNameOptions,
                                                                       setSuperStarNameOptions,
                                                                       showErrors,
                                                                       aaaIdentifierPattern,
                                                                   }) => {
    const REGION = "us-east-1";

    return (
        <Container header={<Header variant="h1">API Onboarding</Header>}>
            <SpaceBetween direction="vertical" size="l">
                <FormField label={<RequiredField label="Environment" />}>
                    <Select
                        selectedOption={formData.environment}
                        onChange={async ({detail}) => {
                            setFormData({...formData, environment: detail.selectedOption})
                            if(detail.selectedOption.label){
                                const requestsServiceDNS = await fetchSuperStarDropDownOptions(detail.selectedOption.label);

                                const transformedServiceDNSOptions = requestsServiceDNS.map(request => ({
                                    label: request.superStar,
                                    value: request.superStar,
                                    description: request.domainName,
                                }));
                                setSuperStarNameOptions(transformedServiceDNSOptions)
                            }
                        }}
                        options={[
                            {label: "ALPHA", value: "ALPHA"},
                            {label: "BETA", value: "BETA"},
                            {label: "GAMMA", value: "GAMMA"},
                            {label: "PROD", value: "PROD"}
                        ]}
                        placeholder="Select env type"
                    />
                </FormField>

                <FormField label="Region">
                    <Input
                        value={REGION}
                        disabled={true}
                    />
                </FormField>

                <FormField
                    label={<RequiredField label="Superstar Service Name" />}>

                    <Select
                        onFocus={() => {
                            if(formData.environment === null){
                                window.alert("Please select environment before")
                            }
                        }}
                        selectedOption={formData.superStar}
                        onChange={({detail}) => setFormData({...formData, superStar: detail.selectedOption})}
                        options={superStarNameOptions}
                        placeholder="Select Superstar service name"

                    />

                </FormField>

                <FormField label="Enable Client Authentication">
                    <RadioGroup
                        items={[
                            { value: "true", label: "True", disabled: false },
                            { value: "false", label: "False", disabled: true }
                        ]}
                        ariaLabel="Client Authentication"
                        value="true"
                        onChange={() => {}}
                    />
                </FormField>

                <FormField label={<RequiredField label="Enable Client Authorization" />}>
                    <RadioGroup
                        value={formData.clientAuthorization}
                        ariaLabel="Client Authorization"
                        onChange={({detail}) => setFormData({...formData, clientAuthorization:detail.value})}
                        items={[
                            {value: "true", label: "True"},
                            {value: "false", label: "False"}
                        ]}
                    />
                </FormField>

                {formData.clientAuthorization === "true" &&
                    (
                        <FormField
                            label="Custom Action">
                            <RadioGroup
                                value={formData.customActionExist}
                                onChange={({detail}) => setFormData({...formData,customActionExist:detail.value})}
                                items={[
                                    {value: "true", label: "Custom action"},
                                    {value: "false", label: "Http action"}
                                ]}
                            />
                            {formData.customActionExist === 'true' &&
                                <Input
                                    value={formData.customAction}
                                    onChange={({detail}) => setFormData({...formData, customAction:detail.value})}
                                    placeholder={"custom action"}
                                />
                            }
                        </FormField>
                    )
                }

                {formData.customActionExist === 'true' &&
                    <FormField label={<RequiredField label="Resource URN Template" />}><Input
                        value={formData.resourceUrnTemplate}
                        onChange={({detail}) => setFormData({...formData,resourceUrnTemplate:detail.value})}
                        placeholder={"Resource URN Template"}
                    />
                    </FormField>
                }

                <FormField label={<RequiredField label="Cross-Origin Resource Sharing(CORS) Enabled" />}>
                    <RadioGroup
                        ariaLabel="CORS Enabled"
                        value={formData.corsEnabled}
                        onChange={({detail}) => setFormData({...formData, corsEnabled: detail.value})}
                        items={[
                            {value: "true", label: "True"},
                            {value: "false", label: "False"}
                        ]}
                    />
                </FormField>

                {formData.corsEnabled === "true" && (
                    <FormField label="CORS Headers">
                        <SpaceBetween direction="vertical" size="xs">
                            {formData.corsHeaders.map((header, index) => (
                                <SpaceBetween direction="horizontal" size="xs" key={index}>
                                    <Input
                                        placeholder="Enter CORS header"
                                        value={header}
                                        onChange={({detail}) => {
                                            const newHeaders = [...formData.corsHeaders];
                                            newHeaders[index] = detail.value;
                                            setFormData({...formData, corsHeaders: newHeaders});
                                        }}
                                    />
                                    <Button
                                        iconName="remove"
                                        variant="icon"
                                        onClick={() => {
                                            const newHeaders = formData.corsHeaders.filter((_, i) => i !== index);
                                            setFormData({...formData, corsHeaders: newHeaders});
                                        }}
                                    />
                                </SpaceBetween>
                            ))}
                            <Button
                                onClick={() => {
                                    setFormData({
                                        ...formData,
                                        corsHeaders: [...formData.corsHeaders, ""]
                                    });
                                }}
                            >
                                +
                            </Button>
                        </SpaceBetween>
                    </FormField>
                )}


                <FormField label={<RequiredField label="HTTP Resource" />}
                           errorText={showErrors && !RESOURCE_REGEX_PATTERN.test(formData.resource) ? "Invalid input format" : undefined}>
                    <Input
                        value={formData.resource}
                        onChange={({detail}) => setFormData({...formData, resource:detail.value})}
                        placeholder="api/{version}/resource/{id}"
                    />
                </FormField>

                <FormField label={<RequiredField label="AAA Identifier" />}
                           errorText={showErrors && !aaaIdentifierPattern.test(formData.aaaIdentifier) ? "Invalid AAA Identifier format" : undefined}>
                    <Input
                        value={formData.aaaIdentifier}
                        onChange={({detail}) => setFormData({...formData, aaaIdentifier: detail.value})

                        }
                        placeholder="https://aaa.amazon.com/scopes/DS2LimeAuthNService#GetLoginUrl"

                    />
                </FormField>

            </SpaceBetween>
        </Container>
    );
};

export default APIOnboardingSection;
